module.exports = __webpack_public_path__ + "static/media/close-text.e2a599ca.svg";